'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function drawPointyArc(d) {
  var dx = d.source.x - d.target.x;
  var dy = d.source.y - d.target.y;
  var arcRadius = window.NODE_SIZE * dx / Math.abs(dx);
  var theta = void 0;
  var edgePoint = void 0;
  var front = void 0;
  var back = void 0;
  var arc = void 0;

  if (dx === 0) {
    if (dy >= 0) {
      theta = Math.PI;
    } else {
      theta = -Math.PI;
    }
    edgePoint = {
      x: 0,
      y: window.NODE_SIZE / 2
    };
  } else {
    theta = Math.atan((d.source.y - d.target.y) / (d.source.x - d.target.x)) + Math.PI / 2;
    edgePoint = {
      x: window.NODE_SIZE / 2 * Math.cos(theta),
      y: window.NODE_SIZE / 2 * Math.sin(theta)
    };
  }
  front = {
    x: d.target.x + edgePoint.x,
    y: d.target.y + edgePoint.y
  };
  back = {
    x: d.target.x - edgePoint.x,
    y: d.target.y - edgePoint.y
  };
  arc = {
    x: (d.target.x + d.source.x) / 2 + arcRadius * Math.cos(theta),
    y: (d.target.y + d.source.y) / 2 + arcRadius * Math.sin(theta)
  };
  return 'M' + front.x + ',' + front.y + 'Q' + arc.x + ',' + arc.y + ',' + d.source.x + ',' + d.source.y + 'Q' + arc.x + ',' + arc.y + ',' + back.x + ',' + back.y + 'Z';
}

exports.default = {
  drawPointyArc: drawPointyArc
};


//////////////////
// WEBPACK FOOTER
// ./edgeTechniques.js
// module id = 6
// module chunks = 0